import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ChevronRight, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BuyerAPI } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import ProductCard from '../components/ProductCard';

// BUG 8 fix: bouton retirer des favoris sur chaque carte
const Favorites = ({ onAddToCart }) => {
  const { t }     = useTranslation();
  const { user }  = useAuth();
  const { toast } = useToast();
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!user) return;
    setLoading(true);
    BuyerAPI.favorites().then(setItems).finally(() => setLoading(false));
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const remove = async (productId, name) => {
    try {
      await BuyerAPI.removeFavorite(productId);
      setItems(prev => prev.filter(p => p.id !== productId));
      toast({ title: 'Retiré des favoris', description: name });
    } catch {
      toast({ title: 'Erreur', description: 'Impossible de retirer ce favori.' });
    }
  };

  if (!user) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-16 text-center">
        <Heart className="w-12 h-12 text-[#C9BFAE] mx-auto mb-3" />
        <p className="text-[#5A5247] mb-4">{t('favorites.login_required')}</p>
        <Link to="/connexion" className="inline-block bg-[#1F4D3F] text-white px-6 py-2.5 rounded-xl font-medium hover:bg-[#173B30]">
          {t('common.login')}
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <nav className="flex items-center gap-1.5 text-sm text-[#7A6F5C] mb-4">
        <Link to="/" className="hover:text-[#1F4D3F]">{t('common.account')}</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-[#2D2A26]">{t('favorites.title')}</span>
      </nav>
      <h1 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F] mb-6">
        {t('favorites.title')} <span className="text-[#7A6F5C] text-2xl font-normal">({items.length})</span>
      </h1>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-white border border-[#E8E0D0] rounded-xl h-64 animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-[#E8E0D0] rounded-2xl p-12 text-center">
          <Heart className="w-12 h-12 text-[#C9BFAE] mx-auto mb-3" />
          <p className="text-[#5A5247] font-medium">{t('favorites.empty_title')}</p>
          <p className="text-[#7A6F5C] text-sm mt-1">{t('favorites.empty_desc')}</p>
          <Link to="/categories" className="inline-block mt-4 text-[#1F4D3F] font-medium hover:underline">
            {t('cart.continue_shopping')}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((p) => (
            <div key={p.id} className="relative group">
              <ProductCard product={p} onAddToCart={onAddToCart} />
              <button
                onClick={() => remove(p.id, p.name)}
                className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white border border-[#E8E0D0]
                           flex items-center justify-center opacity-0 group-hover:opacity-100
                           transition-opacity hover:bg-red-50 hover:border-red-200 shadow-sm z-10"
                title={t('product.remove_favorite')}
              >
                <Trash2 className="w-3.5 h-3.5 text-red-400" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
